<template>
  <div class="wrap">
    <Navbar background="transparent" fixed />
    <!-- <ServiceBtn textShow />
    <div class="logo">
      <img :src="require('@/assets/logo/login.png')" class="logo_img" alt="">
    </div> -->
    <div class="icon_lang" @click="showLang">
      <img src="../../assets/new/lang_.png" class="langicon" alt="">
    </div>
    <div class="deline"></div>
    <div class="deline1"></div>
    <div class="partners">
      <div class="partners_item">
        <img src="../../assets/login/1.png" alt="">
        <span>{{ $t('水晶宫') }}</span>
      </div>
      <div class="partners_item">
        <img src="../../assets/login/2.png" alt="">
        <span>{{ $t('皇家马德里') }}</span>
      </div>
      <div class="partners_item">
        <img src="../../assets/login/3.png" alt="">
        <span>{{ $t('国际米兰') }}</span>
      </div>
      <div class="partners_item">
        <img src="../../assets/login/4.png" alt="">
        <span>{{ $t('AC米兰') }}</span>
      </div>
    </div>
    <div class="form_wrap_bar">
      <div class="tab">
        <div class="tab_item" :class="index == tabNum ? 'active_item' : ''" v-for="item, index in tab" :key="index"
          @click="tabNum = index">
          {{ $t(item) }}
        </div>
      </div>
      <LoginForm :formList="formData" cancelText="Login.Forgot.goBack" confirmText="page.registrasi"
        readText="hint.registeRead" :needRead="true" @cancel="handleClose" @submit="onSubmit" :tab-num="tabNum"
        @defaultValue="valueChange">
        <template #surfix_code>
          <div class="sned_code" @click.stop="sendCode" v-if="tabNum == 0">{{ time ? time : $t('发送') }}</div>
          <div class="sned_code" @click.stop="sendEmailCode" v-else>{{ emailTime ? emailTime : $t('发送') }}</div>
        </template>
      </LoginForm>
      <div class="btns">
        <div class="btn" @click="handleClose">
          <img src="../../assets/login/signup.png" alt="">
          <span>{{ $t('立即登录') }}</span>
        </div>
        <div class="btn" @click="getHome">
          <img src="../../assets/login/kefu.png" alt="">
          <span>{{ $t('在线客服') }}</span>
        </div>
      </div>
      <!-- <div class="already_account">
        <span>{{ $t("已有账户") }}</span>
        <span @click="handleClose" class="register">{{
          $t("page.login")
        }}</span>
      </div> -->
    </div>
     <van-action-sheet v-model="show2" :actions="verConfig.lans || Lans" @close="onClose" @select="onSelect" />
  </div>
</template>

<script>
import Navbar from "@/components/JNav";
import { Icon, Image as VImg, Toast,ActionSheet } from "vant";
import LoginForm from "./components/form.vue";
import { SEND_SMS_CODE, LOGIN, HOME_IMG, EMAIL_CODE } from "@/api";
import { getNewPhone } from "@/utils/tools";
import { getCookieValue, baseEncode } from "@/utils/common";
import ServiceBtn from "@/components/serviceBtn";
import { Lans, getLanguage } from "@/i18n";
export default {
  components: {
    Icon,
    VImg,
    LoginForm,
    ServiceBtn,
    Navbar,
    [ActionSheet.name]: ActionSheet,
  },
  data() {
    this.Lans = Lans;
    return {
      langicon: "",
      langtext: "",
      formList: [
        {
          key: "email",
          flag: true,
          // icon: "icon-yonghuming",
          label: "Login.emailInput",
          rules: [{ required: true, message: this.$t("Login.emailInput") }],
          img: require('../../assets/login/email.png'),
        },
        {
          key: "userphone",
          flag: true,
          // icon: "icon-yonghuming",
          label: "Login.nameInput",
          needTrue: true,
          rules: [{ required: true, message: this.$t("hint.usernameEnter") }],
        },
        {
          key: "code",
          flag: true,
          label: "验证码",
          img: require('../../assets/login/code.png'),
          rules: [{ required: true, message: this.$t("验证码") }],
        },
        {
          label: "Login.Daftar.password",
          type: "password",
          key: "userpass",
          // icon: "icon-zhanghumima",
          flag: true,
          rules: [{ required: true, message: this.$t("hint.passwordEnter") }],
          img: require('../../assets/login/password.png'),
          isPassword: true,
        },
        {
          label: "Login.Daftar.againPassword",
          type: "password",
          key: "againPassword",
          // icon: "icon-zhanghumima",
          flag: false,
          rules: [
            { required: true, message: this.$t("hint.passwordAgainEnter") },
          ],
          img: require('../../assets/login/password.png'),
          isPassword: true,
        },
        {
          label: "Login.Daftar.referrer",
          type: "text",
          // icon: "icon-yaoqing2",
          img: require('../../assets/login/referrer.png'),
          key: "fromid",
          flag: true,
          rules: [{ required: true, message: this.$t("hint.formidEnter") }],
        },
      ],
      defaultValue: {},
      tab: ['loginType.phone', 'loginType.email'],
      tabNum: 0,
      time: 0,
      emailTime: 0,
      show2: false
    };
  },
  computed: {
    formData() {
      if (this.tabNum == 0) {
        return this.formList.filter(item => item.key != 'email');
      }
      return this.formList.filter(item => item.key != 'userphone');
    }
  },
  created() {
    Lans.forEach((item) => {
      if (item.value == getLanguage()) {
        this.langicon = item.icon;
        this.langtext = item.name;
      }
    });
  },
  methods: {
    showLang() {
      this.show2 = true;
    },
    onClose() {
      this.show2 = false;
    },
    onSelect(e) {
      this.$i18n.Locale = e.value;
      this.changeLanguage(e.value);
      Cookies.set("lang", e.value);
      this.language = e.value;
      this.show2 = false;
      this.langicon = e.icon;
      this.langtext = e.name;
    },
    valueChange(value) {
      this.defaultValue = value;
    },
    sendCode() {
      if (!this.defaultValue.userphone) return;
      if (this.time != 0) return;
      Toast.loading();
      const { country_code } = this.defaultValue;
      let userphone = country_code && country_code.split('+')[1] + this.defaultValue.userphone;
      SEND_SMS_CODE({
        userphone: userphone,
      }).then(res => {
        if (res.data.ret === 1) {
          Toast(res.data.msg)
          let times = 60;
          let timer = setInterval(() => {
            times--;
            this.time = times;
            if (times == 0) {
              clearInterval(timer)
            }
          }, 1000)
        } else {
          Toast(res.data.msg)
        }
      }).catch(err => {
        Toast.clear()
      })
    },
    async sendEmailCode() {
      if (!this.defaultValue.email) return;
      if (this.emailTime != 0) return;
      Toast.loading();
      try {
        const res = await EMAIL_CODE({
          email: this.defaultValue.email
        })
        let times = 60;
        let timer = setInterval(() => {
          times--;
          this.emailTime = times;
          if (times == 0) {
            clearInterval(timer)
          }
        }, 1000)
        Toast(res.msg)
      } catch (error) {
        Toast(error.msg)
      }
    },
    onSubmit(values) {
      Toast.loading({ duration: 0 });
      const { againPassword, ...useValues } = values;
      if (againPassword === useValues.userpass) {
        if (!this.formList.find((item) => item.key === "code")) {
          useValues.code = "112233";
        }
        LOGIN({
          ...useValues,
          channel: getCookieValue("channel") || baseEncode(),
        })
          .then((r) => {
            if (r.data.ret === 1) {
              this.$cookie.set("userInfo", JSON.stringify(r.data.data));
              this.$cookie.set("token", r.data.data.token);
              if (this.$cookie.get("fromid")) {
                this.$cookie.remove("fromid");
              }
              this.$store.dispatch("getSystemConfig");
              this.$router.replace("goods");
            } else {
              Toast.clear();
              Toast(r.data.msg);
            }
          })
          .catch((e) => {
            Toast.clear();
            console.log(e);
          });
        return;
      }
      Toast(this.$t("Hint.pwdInconformity"));
    },
    handleClose() {
      this.$router.push('/login');
    },
    async getHome(num = 0) {
      this.$store.dispatch('toService');
      return;
      Toast.loading()
      try {
        const { data } = await HOME_IMG();
        Toast.clear()
        if (data) {
          if (data[num]) return window.location.href = data[num].paramet.url;
          const find = data.find(item => item.paramet.url);
          window.location.href = find.paramet.url;
        }
      } catch (error) {
        Toast.clear();
      }
    },
  },
};
</script>

<style lang="less" scoped>
.wrap {
  background: var(--bg);
  min-height: 100vh;
  overflow: hidden;
  background-size: 100% 100%;
  background-repeat: no-repeat;
  background-image: url("../../assets/login/bg.png");
  display: flex;
  align-items: center;
  flex-direction: column;

  /deep/ .van-nav-bar__left {
    .van-icon-arrow-left {
      color: var(--theme) !important;
    }
  }
  /deep/ .van-nav-bar--fixed{
    left: 50% !important;
    transform: translateX(-50%);
  }

  /deep/ .service_btn {
    position: fixed;
    top: calc(20rem / 16);
    right: calc(20rem / 16);
    display: flex;
    flex-direction: column;
    align-items: flex-end;
  }

  .nav {
    // height: calc(50rem / 16);
    color: var(--textColor);
    display: flex;
    align-items: center;
    margin: calc(26rem / 16) calc(17rem / 16) 0;

    .back {
      transform: rotate(90deg);
    }

    .title {
      font-size: calc(24rem / 16);
      margin-left: calc(14rem / 16);
    }
  }
  .icon_lang {
    position: fixed;
    // top: calc(10rem / 16);
    right: calc(20rem / 16);
    height: calc(46rem / 16);
    display: flex;
    align-items: center;
    justify-content: center;
    flex-direction: column;
    z-index:9;

    img {
      height: 35px;
      width: 35px;
      object-fit: contain;
      margin-right: 8%;
    }

    span {
      min-width: 55px;
      color: #fff;
      font-size: calc(14rem / 16);
    }
  }

  .deline {
    background: url('../../assets/login/login_logo.png') top / contain;
    background-repeat: no-repeat;
    width: 100%;
    height: 80px;
    margin: 0 auto;
  }

  .deline1 {
    background: url('../../assets/login/login_header.png') top / contain;
    background-repeat: no-repeat;
    width: 100%;
    height: 23px;
    margin: 0 auto;
    margin-top: 10px;
  }

  .partners {
    width: calc(100% - 40px);
    padding: 20px 0 10px;
    margin: 0 20px;
    display: flex;

    .partners_item {
      display: flex;
      flex-direction: column;
      align-items: center;
      justify-content: center;
      width: 25%;

      img {
        width: 50px;
        height: 50px;
        display: block;
        object-fit: contain;
      }

      span {
        color: var(--theme);
        font-size: 12px;
        margin-top: 5px;
      }
    }
  }

  .form_wrap_bar {
    width: 90%;

    .logo {
      display: flex;
      justify-content: center;

      &_img {
        height: calc(80rem / 16);
        display: block;
      }
    }

    .sned_code {
      background: var(--btn_bg);
      color: var(--light);
      font-size: 14px;
      padding: 5px 10px;
      border-radius: 4px;
    }

    .tab {
      margin: 5px 16px 5px;
      padding: 5px;
      background: #ddd5c7;
      border-radius: 5px;
      display: flex;
      align-items: center;
      justify-content: space-between;

      .tab_item {
        flex: 1;
        text-align: center;
        height: 30px;
        display: flex;
        align-items: center;
        justify-content: center;
        border-radius: 5px;
        padding: 5px;
        color: #101010;
        font-weight: 700;
      }

      .active_item {
        background: #fff;
        color: #b98b37;
      }
    }
  }

  .btns {
    display: flex;
    align-items: center;
    justify-content: space-around;
    gap: 10px;
    margin: 10px auto;

    .btn {
      background: url('../../assets/login/btn1.png') no-repeat 50% / contain;
      font-size: 14px;
      padding: 20px 0 30px;
      color: #1b4983;
      display: flex;
      width: 30%;
      align-items: center;
      justify-content: center;
      flex-direction: column;

      img {
        width: 30px;
        height: 30px;
        display: block;
      }

      span {
        margin-top: 10px;
      }
    }
  }

  .already_account {
    text-align: center;
    color: var(--light);
    font-size: calc(14rem / 16);
    margin-top: calc(15rem / 16);
    white-space: pre-wrap;

    .register {
      color: var(--yellow);
      cursor: pointer;
      text-decoration: underline;
    }
  }
}
</style>
